import { Modal, Button, Space, Typography, Alert } from "antd";
import { LockOutlined, EyeOutlined, BellOutlined, CheckCircleOutlined } from "@ant-design/icons";

const { Text } = Typography;

/**
 * Modal shown when a record is locked by another user.
 * Props:
 *   visible         — show the modal
 *   lockedBy        — { userId, userName }
 *   onViewReadOnly  — callback: user chose to view in read-only
 *   onRequestAccess — callback: user wants to ask for access
 *   releaseRequested — boolean: request already sent
 */
const RecordLockedModal = ({ visible, lockedBy, onViewReadOnly, onRequestAccess, releaseRequested }) => {
  return (
    <Modal
      open={visible}
      closable={false}
      maskClosable={false}
      footer={null}
      centered
      width={420}
    >
      <div style={{ textAlign: "center", padding: "12px 0" }}>
        <LockOutlined style={{ fontSize: 48, color: "#fa8c16", marginBottom: 16 }} />
        <Typography.Title level={4} style={{ margin: "0 0 8px" }}>
          Record In Use
        </Typography.Title>
        <Text type="secondary" style={{ fontSize: 14 }}>
          This record is currently being edited by
        </Text>
        <div style={{
          margin: "12px 0",
          padding: "8px 16px",
          background: "#fff7e6",
          border: "1px solid #ffd591",
          borderRadius: 8,
          display: "inline-block",
        }}>
          <Text strong style={{ fontSize: 15 }}>
            {lockedBy?.userName || "Another user"}
          </Text>
        </div>

        {releaseRequested && (
          <Alert
            type="info"
            showIcon
            icon={<CheckCircleOutlined />}
            message="Access request sent! Waiting for them to release..."
            style={{ marginTop: 12, textAlign: "left" }}
          />
        )}

        <div style={{ marginTop: 20 }}>
          <Space size="middle">
            <Button
              type="primary"
              icon={<EyeOutlined />}
              size="large"
              onClick={onViewReadOnly}
            >
              View Read-Only
            </Button>
            {!releaseRequested && (
              <Button
                icon={<BellOutlined />}
                size="large"
                onClick={onRequestAccess}
              >
                Request Access
              </Button>
            )}
          </Space>
        </div>
      </div>
    </Modal>
  );
};

/**
 * Banner shown to the LOCK HOLDER when someone requests access.
 * Props:
 *   requestFrom        — { userId, userName }
 *   onRelease          — callback: release the lock
 *   onDismiss          — callback: dismiss the notification
 */
export const ReleaseRequestBanner = ({ requestFrom, onRelease, onDismiss }) => {
  if (!requestFrom) return null;

  return (
    <Alert
      type="warning"
      showIcon
      message={
        <span>
          <Text strong>{requestFrom.userName}</Text> is requesting access to this record.
        </span>
      }
      action={
        <Space>
          <Button size="small" type="primary" danger onClick={onRelease}>
            Release & Close
          </Button>
          <Button size="small" onClick={onDismiss}>
            Dismiss
          </Button>
        </Space>
      }
      style={{ marginBottom: 10 }}
    />
  );
};

export default RecordLockedModal;
